import { Fragment, lazy, Suspense } from 'react'

import type { ModalComponent } from '@core/modal/types'

const SettingsModal = lazy(() => import('./SettingsModal'))

/**
 * Lazy loaded version of SettingsModal.
 * Will only be rendered for non mobile web users.
 */
export const StreamSettingModalLazy: ModalComponent = (props) => {
  return (
    <Suspense fallback={<Fragment />}>
      <SettingsModal {...props} />
    </Suspense>
  )
}
